import Request from "../../lib/request";
import { PROJECT_USER_ID } from "../../constants/storageKeys";
import {
  INIT_API,
  MONTHLY_BUDGET_API,
  MONTHLY_BUDGETS_API,
  PROJECT_USERS_API,
  REPORTS_API
} from "../../constants/api";
import { PAGE } from "../../constants/filters";

const baseUrl = process.env.REACT_APP_API_URL;

export const getList = page_number => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${MONTHLY_BUDGETS_API}?${PAGE}=${page_number}`,
    needToken: true
  });
};

export const getInit = () => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${MONTHLY_BUDGETS_API}/${INIT_API}`,
    needToken: true
  });
};

export const store = data => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${MONTHLY_BUDGETS_API}`,
    needToken: true,
    data: data
  });
};

export const show = id => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${MONTHLY_BUDGETS_API}/${id}`,
    needToken: true
  });
};

export const get = data => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${REPORTS_API}/${MONTHLY_BUDGET_API}`,
    needToken: true,
    data
  });
};

export const update = (id, data) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${MONTHLY_BUDGETS_API}/${id}`,
    needToken: true,
    data: data
  });
};

export const remove = id => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "delete",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${MONTHLY_BUDGETS_API}/${id}`,
    needToken: true
  });
};
